import {
    faCalendarDays,
    faChartSimple,
    faGear,
    faHouseWindow,
    faPersonCircleCheck,
    faReceipt,
} from "@fortawesome/pro-solid-svg-icons"
import {
    SERVICE_CENTER_ADMIN_ROUTE,
    SERVICE_CENTER_REPORTS_CALENDAR_ROUTE,
    SERVICE_CENTER_REPORTS_GUESTS_ROUTE,
    SERVICE_CENTER_REPORTS_MEETING_SERVICE_ROUTE,
    SERVICE_CENTER_REPORTS_ROUTE,
    SERVICE_CENTER_REPORTS_STATISTICS_ROUTE,
} from "../../../constants/routes"
import { NarrowNavItem } from "../../../shared/layouts/NarrowNavItems"
import { EnvironmentType } from "../../environment/envTypes"

const defaultEnvs = [EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]

export const serviceCenterReportingNavItems: NarrowNavItem[] = [
    {
        icon: faHouseWindow,
        label: "User",
        translationLabel: "service-center-nav-item-user-label",
        route: SERVICE_CENTER_REPORTS_ROUTE,
        environments: defaultEnvs,
    },
    {
        icon: faReceipt,
        label: "Canteen",
        translationLabel: "service-center-nav-item-canteen-label",
        route: SERVICE_CENTER_REPORTS_MEETING_SERVICE_ROUTE,
        environments: defaultEnvs,
    },
    {
        icon: faCalendarDays,
        label: "Calendar",
        translationLabel: "service-center-nav-item-calendar-label",
        route: SERVICE_CENTER_REPORTS_CALENDAR_ROUTE,
        environments: defaultEnvs,
    },
    {
        icon: faPersonCircleCheck,
        label: "Guests",
        translationLabel: "service-center-nav-item-guests-label",
        route: SERVICE_CENTER_REPORTS_GUESTS_ROUTE,
        environments: [...defaultEnvs, EnvironmentType.QA, EnvironmentType.Prod],
    },
    {
        icon: faChartSimple,
        label: "Reports",
        translationLabel: "service-center-nav-item-reports-label",
        route: SERVICE_CENTER_REPORTS_STATISTICS_ROUTE,
        environments: defaultEnvs,
    },
    {
        icon: faGear,
        label: "Settings",
        translationLabel: "service-center-nav-item-settings-label",
        route: SERVICE_CENTER_ADMIN_ROUTE,
        environments: defaultEnvs,
    },
]
